document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', function(e) {
    // Poišči odprt modal
    var modal = document.querySelector('.product-media-modal__dialog[role="dialog"]');
    if (!modal) return;

    // Če je klik v modal (tudi na sliko ali ozadje)
    if (modal.contains(e.target)) {
      // Zapri modal (če obstaja close button)
      var closeBtn = modal.querySelector('button.product-media-modal__toggle');
      if (closeBtn) closeBtn.click();
    }
  }, true);
});
